module.exports = __webpack_public_path__ + "img/instagram-512.efbac426.png";